import React, { useEffect, useRef } from "react";

const ConvergePayButton = () => {
  const buttonRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.convergepay.com/hosted-payments/buy_button_script/77624743465a304e517279313256386a5269586a37674141415a716931647642";
    script.async = true;

    if (buttonRef.current && buttonRef.current.parentNode) {
      buttonRef.current.parentNode.appendChild(script);
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div>
      <button
        ref={buttonRef}
        disabled
        style={{
          color: "#ffffff",
          fontSize: "14px",
          fontFamily: "Trebuchet MS, sans-serif",
          fontWeight: "normal",
          backgroundColor: "#4177B4",
          padding: "7px 16px",
          display: "inline-block",
          borderRadius: "3px",
          border: "1px solid #4A90E2",
          boxShadow: "0 2px 4px 0 rgba(0,0,0,0.25)",
        }}
      >
        PAY NOW
      </button>
    </div>
  );
};

export default ConvergePayButton;
